interface FeatureConfig {
  [k: string]: {
    value: string | number | boolean
    description: string
    created_at?: string
    example?: string
    updated_at?: string
  }
}

const featureDefaults: FeatureConfig = {
  'enable.care_plans': {
    value: false,
    description: 'FULF-1000 - rollback care plans',
  },
}

export default class MissionControl {
  private features: FeatureConfig

  private isReady: boolean

  private readonly requestToGetConfig: Function

  constructor(request: Function) {
    this.requestToGetConfig = request

    this.features = {}
    this.isReady = false
  }

  private async fetchData() {
    const configResponse = await this.requestToGetConfig()

    if (!configResponse) {
      throw new Error("MissionControl: backend didn't respond.")
    }

    if (Object.prototype.hasOwnProperty.call(configResponse, 'data')) {
      return configResponse.data
    }

    throw new Error(
      'MissionControl: odd response from the backend -> data is undefined.',
    )
  }

  isReadyForQueries() {
    return this.isReady
  }

  async init() {
    if (this.isReady) {
      return this.features
    }

    const newState = await this.fetchData()

    if (newState) {
      this.isReady = true
      this.features = {
        ...featureDefaults,
        ...newState,
      }
      return newState
    }

    this.isReady = false
    throw new Error('Mission Control failed to get config data.')
  }

  getConfig(configKey: string) {
    if (
      !this.isReady ||
      !Object.prototype.hasOwnProperty.call(this.features, configKey)
    ) {
      return false
    }

    return this.features[configKey]
  }

  isFeatureEnabled(configKey: string) {
    if (
      !this.isReady ||
      !Object.prototype.hasOwnProperty.call(this.features, configKey)
    ) {
      return false
    }

    return Boolean(this.features[configKey].value) === true
  }
}
